import React from 'react';

export const ArcherContext = React.createContext({
    country: '',
    setCountry: () => null,
    currency: '',
    setCurrency: () => null,
    size: '',
    setSize: () => null,
    heatingType: '',
    setHeatingType: () => null,
    renewableElectricity: true,
    setRenewableElectricity: () => null,
    resultLookupTableIndex: -1,
    setResultLookupTableIndex: () => null
});

const ArcherContextProvider = (props) => {

    const [country, setCountry] = React.useState('');
    const [currency, setCurrency] = React.useState('');
    const [size, setSize] = React.useState('');
    const [heatingType, setHeatingType] = React.useState('');
    const [resultLookupTableIndex, setResultLookupTableIndex] = React.useState(-1);
    const [renewableElectricity, setRenewableElectricity] = React.useState(true);

    return (
        <ArcherContext.Provider value={{
            country,
            setCountry,
            currency,
            setCurrency,
            size,
            setSize,
            heatingType,
            setHeatingType,
            renewableElectricity,
            setRenewableElectricity,
            resultLookupTableIndex,
            setResultLookupTableIndex
        }}>
            {props.children}
        </ArcherContext.Provider>
    );
};

export default ArcherContextProvider;
